import { CASE_SEARCH_PARAMS_SCHEMA } from '@repo/ccc-case-app-lib/src/constants/caseSearchParamsSchema.ts'
import { UserCaseOverviewPage } from '@repo/ccc-case-app-lib/src/pages/UserCaseOverviewPage.tsx'
import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

const userSearchParamsSchema = v.object({
  publicCaseId: v.optional(v.string()),
  // Include case list state parameters for navigation persistence
  ...CASE_SEARCH_PARAMS_SCHEMA.entries,
})

export const Route = createFileRoute('/_authenticated/user/$userId')({
  component: UserCaseOverviewComponent,
  validateSearch: userSearchParamsSchema,
})

function UserCaseOverviewComponent() {
  const { userId } = Route.useParams()

  return <UserCaseOverviewPage userId={userId} />
}
